<template>
  <div class="date-time-picker">
    <el-date-picker
      v-model="date"
      type="date"
      class="date-time-picker__date"
      format="DD/MM/YYYY"
      value-format="YYYY-MM-DD"
      @change="emitValue"
    />
    <time-picker v-model="time" class="date-time-picker__time" @change="emitValue" />
  </div>
</template>

<script>
import TimePicker from './TimePicker.vue';

// Date + time as separate fields. v-model is "YYYY-MM-DDTHH:mm" (local), or '' until both parts are set.
export default {
  name: 'DateTimePicker',
  components: { TimePicker },
  props: {
    modelValue: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      date: this.modelValue ? this.modelValue.slice(0, 10) : '',
      time: this.modelValue ? this.modelValue.slice(11, 16) : '',
    };
  },
  computed: {
    value() {
      return this.date && this.time ? `${this.date}T${this.time}` : '';
    },
  },
  watch: {
    modelValue(v) {
      // Ignore our own emits so a half-filled field (date without time) isn't wiped
      if ((v || '') === this.value) return;
      this.date = v ? v.slice(0, 10) : '';
      this.time = v ? v.slice(11, 16) : '';
    },
  },
  methods: {
    emitValue() {
      if (this.value === (this.modelValue || '')) return;
      this.$emit('update:modelValue', this.value);
      this.$emit('change', this.value);
    },
  },
};
</script>

<style scoped>
.date-time-picker {
  display: flex;
  gap: 8px;
}
.date-time-picker .date-time-picker__date {
  flex: 1 1 0;
  width: auto;
  min-width: 0;
}
.date-time-picker .date-time-picker__time {
  flex: 0 0 110px;
}
</style>
